import {message, ConfigProvider} from 'antd';
import {Message} from "./biz/Components";
import Routes from "./routes";
import {useLocation, useNavigate, useRoutes} from "react-router";

import zh_CN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');

import 'antd/dist/reset.css';
import './App.css';
import "./common.less"
import "./mixins.less"
import HomePage from "./pages/home";


window.CONFIG = require('@/utils/config').default;
window.ENUMS = require('@/constants/enums').default;

export const ADMIN_THEME = {
    token: {
        colorPrimary: '#34363f',
        colorPrimaryHover: '#4a4d56',
        colorPrimaryBg: '#eceef0',
        colorPrimaryBgHover: '#e3e5e8',
        colorText: '#1f2329',
        colorTextSecondary: '#646a73',
        colorBorder: '#e5e6eb',
        colorBgLayout: '#f2f4f7',
        borderRadius: 6,
        controlHeight: 36,
        fontSize: 14,
    },
    components: {
        Button: {
            primaryShadow: 'none',
        },
        Menu: {
            colorItemBgSelected: '#eceef0',
            colorItemTextSelected: '#34363f',
        },
        Table: {
            headerBg: '#f7f8fa',
            headerColor: '#1f2329',
            rowHoverBg: '#f5f5f6',
        },
    },
};

function App() {
    const [messageApi, contextHolder] = message.useMessage();
    Message.init(messageApi);
    const location = useLocation();

    // 方便路由跳转
    window.RouterGo=useNavigate();
    return (
        <div className="App">
            {contextHolder}
            <ConfigProvider
                locale={zh_CN}
                theme={ADMIN_THEME}
            >
            <HomePage location={location}>
                {useRoutes(Routes)}
            </HomePage>
            </ConfigProvider>
        </div>
    );
}

export default App;
